import React, { useState } from 'react';
import { useAuth } from '../../auth';
import NewTicketForm from './NewTicketForm';
import MyTicketsView from './MyTicketsView';
import AdminTicketsView from './AdminTicketsView';

type Tab = 'new' | 'mine' | 'manage';

const TicketsContainer: React.FC = () => {
  const { isAdmin } = useAuth();
  const [tab, setTab] = useState<Tab>('new');
  const [reloadKey, setReloadKey] = useState(0);

  const tabs: { id: Tab; label: string; visible: boolean }[] = [
    { id: 'new', label: 'Nueva petición', visible: true },
    { id: 'mine', label: 'Mis tickets', visible: true },
    { id: 'manage', label: 'Gestionar', visible: isAdmin },
  ];

  const handleCreated = () => {
    // Refresca la lista de "Mis tickets" para la próxima vez que se abra.
    setReloadKey((k) => k + 1);
  };

  return (
    <div>
      <div className="flex gap-1 mb-4 border-b border-[#334155] overflow-x-auto">
        {tabs
          .filter((t) => t.visible)
          .map(({ id, label }) => {
            const active = tab === id;
            return (
              <button
                key={id}
                onClick={() => setTab(id)}
                className={`px-3 sm:px-4 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  active
                    ? 'border-[#1f9e3f] text-white'
                    : 'border-transparent text-[#94a3b8] hover:text-white'
                }`}
              >
                {label}
              </button>
            );
          })}
      </div>

      {tab === 'new' && <NewTicketForm onCreated={handleCreated} />}
      {tab === 'mine' && <MyTicketsView reloadKey={reloadKey} />}
      {tab === 'manage' && isAdmin && <AdminTicketsView />}
    </div>
  );
};

export default TicketsContainer;
